import { useNuxtApp } from "#app";
export const useVehicleType = ({ type }) => {
  const {
    $i18n: { t }
  } = useNuxtApp();
  const isVehicleStringType = (x) => ["lowprofile", "coachbuilt", "aclass", "campervan", "van", "caravan", "other", "combi"].includes(x);
  const toVehicleStringType = (type2) => {
    if (typeof type2 === "number") {
      const typeNumberMap = {
        1: "lowprofile",
        2: "coachbuilt",
        3: "aclass",
        4: "campervan",
        5: "van",
        6: "caravan",
        7: "other"
      };
      return typeNumberMap[type2];
    }
    const coercedType = type2.toLowerCase();
    return isVehicleStringType(coercedType) ? coercedType : null;
  };
  const vehicleType = toVehicleStringType(type);
  const typeStringMap = {
    lowprofile: t("data.vehicle.type.options.lowprofile"),
    coachbuilt: t("data.vehicle.type.options.coachbuilt"),
    aclass: t("data.vehicle.type.options.aclass"),
    campervan: t("data.vehicle.type.options.campervan"),
    van: t("data.vehicle.type.options.van"),
    caravan: t("data.vehicle.type.options.caravan"),
    other: t("data.vehicle.type.options.other"),
    combi: t("data.vehicle.type.options.combi")
  };
  return vehicleType ? typeStringMap[vehicleType] ?? null : null;
};
